import script from "./OrganizationLogin.vue?vue&type=script&setup=true&lang=js"
export * from "./OrganizationLogin.vue?vue&type=script&setup=true&lang=js"

import "./OrganizationLogin.vue?vue&type=style&index=0&id=39f43bea&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39f43bea"]])

export default __exports__